export enum NotificationType {
    PATTERN_ALERT = 'pattern_alert',
    SUBSCRIPTION_WARNING = 'subscription_warning',
}

export interface PatternAlertMessage {
    ticker: string;
    timeframe: string;
    timestamp: string;
    pattern_unique_id: string;
    timestamp_end_subpattern_live: number;
    timestamp_start_subpattern_live: number;
}

export interface SubscriptionWarningMessage {
    message: string;
    [key: string]: unknown;
}

// Discriminated union for notifications
export type Notification =
    | {
          id: number;
          timestamp: string;
          read: boolean;
          delivered: boolean;
          tipo: NotificationType.PATTERN_ALERT;
          messaggio: PatternAlertMessage;
      }
    | {
          id: number;
          timestamp: string;
          read: boolean;
          delivered: boolean;
          tipo: NotificationType.SUBSCRIPTION_WARNING;
          messaggio: SubscriptionWarningMessage;
      };

export interface NotificationsParams {
    limit?: number;
    offset?: number;
}

export type NotificationPaginatedResponse = {
    results: Notification[];
    count: number;
    next: string | null;
    previous: string | null;
};
